import { render, staticRenderFns } from "./firewall_detail.vue?vue&type=template&id=247412cc&scoped=true"
import script from "./firewall_detail.vue?vue&type=script&lang=js"
export * from "./firewall_detail.vue?vue&type=script&lang=js"
import style0 from "./firewall_detail.vue?vue&type=style&index=0&id=247412cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247412cc",
  null
  
)

export default component.exports